/**
 * @(#)2019/6/17.
 * String，可以输入所有内容
 * @author 飞光
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import KindEditor from "./kindEditor";
import PropTypes from "prop-types";
import { IYxInputPropTypes } from "../IpropType/basePropType";
import { IUploadConifgPropType } from "../YxUpload";
KindEditor.propTypes = {
  ...IYxInputPropTypes,
  uploadConfig: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape(IUploadConifgPropType),
  ]),
  editorParam: PropTypes.object,
};
//默认props
KindEditor.defaultProps = {
  getFieldDecoratorParam: {},
  rules: {},
  disable: false, // 是否禁用富文本
  editorParam: {}, // 富文本参数
  /**
   * 富文本实例初始化
   *
   * @param {*} editItem 富文本实例
   */
  load: function (editItem) {},
};
export default KindEditor;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/KindEditor/index.js